import PersonModel from '../model/PersonModel'
import PersonGenderOptions from '../constants/PersonGenderOptions'
import PersonMaritalStatusOptions from '../constants/PersonMaritalStatusOptions'
import CountryOptions from '../../constants/CountryOptions'
import ImageSelectControl from '../../../lib/ui/ImageSelectControl'
import TextControl from '../../../lib/ui/TextControl'
import SelectControl from '../../../lib/ui/SelectControl'
import DateControl from '../../../lib/ui/DateControl'
import StaticControl from '../../../lib/ui/StaticControl'
import PhonenumberControl from '../../../lib/ui/PhonenumberControl'
import EmailControl from '../../../lib/ui/EmailControl'
import LinkedinControl from '../../../lib/ui/LinkedinControl'
import FacebookControl from '../../../lib/ui/FacebookControl'
import SkypeControl from '../../../lib/ui/SkypeControl'
import TwitterControl from '../../../lib/ui/TwitterControl'
import CheckboxControl from '../../../lib/ui/CheckboxControl'
import GoogleMapsButtonControl from '../../../lib/ui/GoogleMapsButtonControl'

export default class PersonForm {
  constructor (element, args) {
    let fieldsetPersonal = document.createElement('fieldset')
    let legendPersonal = document.createElement('legend')
    legendPersonal.innerHTML = 'Persoonsgegevens'
    fieldsetPersonal.appendChild(legendPersonal)

    this.id = args.person.values.id
    this.image = new ImageSelectControl(fieldsetPersonal, {label: 'Afbeelding', value: args.person.values.image, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.lastname = new TextControl(fieldsetPersonal, {label: 'Achternaam', value: args.person.values.lastname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.suffix = new TextControl(fieldsetPersonal, {label: 'Tussenvoegsels', value: args.person.values.suffix, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.maidenname = new TextControl(fieldsetPersonal, {label: 'Meisjesnaam', value: args.person.values.maidenname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.maidensuffix = new TextControl(fieldsetPersonal, {label: 'Meisjestussenvoegsels', value: args.person.values.maidensuffix, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.forenames = new TextControl(fieldsetPersonal, {label: 'Voornamen', value: args.person.values.forenames, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.initials = new TextControl(fieldsetPersonal, {label: 'Voorletters', value: args.person.values.initials, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.nickname = new TextControl(fieldsetPersonal, {label: 'Roepnaam', value: args.person.values.nickname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.gender = new SelectControl(fieldsetPersonal, {label: 'Geslacht', value: args.person.values.gender, options: PersonGenderOptions, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})

    let fieldsetBackground = document.createElement('fieldset')
    let legendBackground = document.createElement('legend')
    legendBackground.innerHTML = 'Achtergrond gegevens'
    fieldsetBackground.appendChild(legendBackground)

    this.calculateAge = () => {
      if (!this.dateofbirth.getValue()) {
        this.age.setValue('Onbekend')
        return
      }

      let beginDate = new Date(this.dateofbirth.getValue())

      if (isNaN(beginDate)) {
        this.age.setValue('Onbekend')
        return
      }

      let endDate = new Date()

      if (this.dateofdeath.getValue()) {
        endDate = new Date(this.dateofdeath.getValue())
        if (isNaN(endDate)) {
          endDate = new Date()
        }
      }

      let calculatedAge = endDate.getFullYear() - beginDate.getFullYear()

      let month = endDate.getMonth() - beginDate.getMonth()
      if (month < 0 || month === 0 && endDate.getDate() < beginDate.getDate()) {
        calculatedAge--
      }

      if (calculatedAge < 0) {
        calculatedAge = 0
      }

      this.age.setValue(calculatedAge)
    }

    this.nationality = new SelectControl(fieldsetBackground, {label: 'Nationaliteit', value: args.person.values.nationality, options: CountryOptions, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.countryoforigin = new SelectControl(fieldsetBackground, {label: 'Land van herkomst', value: args.person.values.countryoforigin, options: CountryOptions, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.religion = new TextControl(fieldsetBackground, {label: 'Etniciteit', value: args.person.values.religion, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.maritalstatus = new SelectControl(fieldsetBackground, {label: 'Burgelijke staat', value: args.person.values.maritalstatus, options: PersonMaritalStatusOptions, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.dateofbirth = new DateControl(fieldsetBackground, {label: 'Geboortedatum', value: args.person.values.dateofbirth, onchange: (e) => {
        this.calculateAge()
        if (args.onchange) {
          args.onchange(e)
        }
    }})
    this.age = new StaticControl(fieldsetBackground, {label: 'Leeftijd', value: '-', readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.dateofdeath = new DateControl(fieldsetBackground, {label: 'Sterfdatum', value: args.person.values.dateofdeath, onchange: (e) => {
        this.calculateAge()
        if (args.onchange) {
          args.onchange(e)
        }
    }})

    let fieldsetAddress = document.createElement('fieldset')
    let legendAddress = document.createElement('legend')
    legendAddress.innerHTML = 'Woonadres'
    fieldsetAddress.appendChild(legendAddress)

    this.address = new TextControl(fieldsetAddress, {label: 'Adres', value: args.person.values.address, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.zipcode = new TextControl(fieldsetAddress, {label: 'Postcode', value: args.person.values.zipcode, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.city = new TextControl(fieldsetAddress, {label: 'Plaats', value: args.person.values.city, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.region = new TextControl(fieldsetAddress, {label: 'Provincie', value: args.person.values.region, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.country = new SelectControl(fieldsetAddress, {label: 'Land', value: args.person.values.country, options: CountryOptions, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.addressGoogleMaps = new GoogleMapsButtonControl(fieldsetAddress, {getValues: () => {
        return [
          this.address.getValue(),
          this.zipcode.getValue(),
          this.city.getValue(),
          this.region.getValue(),
          this.country.getValue()
        ]
    }})

    let fieldsetContact = document.createElement('fieldset')
    let legendContact = document.createElement('legend')
    legendContact.innerHTML = 'Contact gegevens'
    fieldsetContact.appendChild(legendContact)

    this.phone = new PhonenumberControl(fieldsetContact, {label: 'Telefoon', value: args.person.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.mobile = new PhonenumberControl(fieldsetContact, {label: 'Mobiel', value: args.person.values.mobile, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.email = new EmailControl(fieldsetContact, {label: 'E-mail', value: args.person.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.linkedinid = new LinkedinControl(fieldsetContact, {label: 'LinkedIn ID', value: args.person.values.linkedinid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.twitterid = new TwitterControl(fieldsetContact, {label: 'Twitter ID', value: args.person.values.twitterid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.facebookid = new FacebookControl(fieldsetContact, {label: 'Facebook ID', value: args.person.values.facebookid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.skypeid = new SkypeControl(fieldsetContact, {label: 'Skype ID', value: args.person.values.skypeid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})

    let fieldsetOptions = document.createElement('fieldset')
    let legendOptions = document.createElement('legend')
    legendOptions.innerHTML = 'Opties'
    fieldsetOptions.appendChild(legendOptions)

    this.sendbirthdayemail = new CheckboxControl(fieldsetOptions, {label: 'Verjaardagskaart per e-mail', value: args.person.values.sendbirthdayemail, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.sendbirthdaycard = new CheckboxControl(fieldsetOptions, {label: 'Verjaardagskaart per post', value: args.person.values.sendbirthdaycard, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.sendchristmasemail = new CheckboxControl(fieldsetOptions, {label: 'Kerstkaart per e-mail', value: args.person.values.sendchristmasemail, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})
    this.sendchristmascard = new CheckboxControl(fieldsetOptions, {label: 'Kerstkaart per post', value: args.person.values.sendchristmascard, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange})

    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetPersonal)
    fragment.appendChild(fieldsetBackground)
    fragment.appendChild(fieldsetAddress)
    fragment.appendChild(fieldsetContact)
    fragment.appendChild(fieldsetOptions)

    this.calculateAge()

    element.appendChild(fragment)
  }

  getValue () {
    let person = new PersonModel()
    person.values.id = this.id
    person.values.image = this.image.getValue()
    person.values.lastname = this.lastname.getValue()
    person.values.suffix = this.suffix.getValue()
    person.values.maidenname = this.maidenname.getValue()
    person.values.maidensuffix = this.maidensuffix.getValue()
    person.values.forenames = this.forenames.getValue()
    person.values.initials = this.initials.getValue()
    person.values.nickname = this.nickname.getValue()
    person.values.gender = this.gender.getValue()
    person.values.nationality = this.nationality.getValue()
    person.values.countryoforigin = this.countryoforigin.getValue()
    person.values.religion = this.religion.getValue()
    person.values.maritalstatus = this.maritalstatus.getValue()
    person.values.dateofbirth = this.dateofbirth.getValue()
    person.values.dateofdeath = this.dateofdeath.getValue()
    person.values.address = this.address.getValue()
    person.values.zipcode = this.zipcode.getValue()
    person.values.city = this.city.getValue()
    person.values.region = this.region.getValue()
    person.values.country = this.country.getValue()
    person.values.phone = this.phone.getValue()
    person.values.mobile = this.mobile.getValue()
    person.values.email = this.email.getValue()
    person.values.linkedinid = this.linkedinid.getValue()
    person.values.twitterid = this.twitterid.getValue()
    person.values.facebookid = this.facebookid.getValue()
    person.values.skypeid = this.skypeid.getValue()
    person.values.sendbirthdayemail = this.sendbirthdayemail.getValue()
    person.values.sendbirthdaycard = this.sendbirthdaycard.getValue()
    person.values.sendchristmasemail = this.sendchristmasemail.getValue()
    person.values.sendchristmascard = this.sendchristmascard.getValue()
    return person
  }

  setValue (person) {
    this.id = person.values.id
    this.image.setValue(person.values.image)
    this.lastname.setValue(person.values.lastname)
    this.suffix.setValue(person.values.suffix)
    this.maidenname.setValue(person.values.maidenname)
    this.maidensuffix.setValue(person.values.maidensuffix)
    this.forenames.setValue(person.values.forenames)
    this.initials.setValue(person.values.initials)
    this.nickname.setValue(person.values.nickname)
    this.gender.setValue(person.values.gender)
    this.nationality.setValue(person.values.nationality)
    this.countryoforigin.setValue(person.values.countryoforigin)
    this.religion.setValue(person.values.religion)
    this.maritalstatus.setValue(person.values.maritalstatus)
    this.dateofbirth.setValue(person.values.dateofbirth)
    this.dateofdeath.setValue(person.values.dateofdeath)
    this.address.setValue(person.values.address)
    this.zipcode.setValue(person.values.zipcode)
    this.city.setValue(person.values.city)
    this.region.setValue(person.values.region)
    this.country.setValue(person.values.country)
    this.phone.setValue(person.values.phone)
    this.mobile.setValue(person.values.mobile)
    this.email.setValue(person.values.email)
    this.linkedinid.setValue(person.values.linkedinid)
    this.twitterid.setValue(person.values.twitterid)
    this.facebookid.setValue(person.values.facebookid)
    this.skypeid.setValue(person.values.skypeid)
    this.sendbirthdayemail.setValue(person.values.sendbirthdayemail)
    this.sendbirthdaycard.setValue(person.values.sendbirthdaycard)
    this.sendchristmasemail.setValue(person.values.sendchristmasemail)
    this.sendchristmascard.setValue(person.values.sendchristmascard)

    this.calculateAge()
  }
}



// WEBPACK FOOTER //
// ./js/modules/person/ui/PersonForm.js